import { Box, Container, Grid, Hidden, Stack } from '@mui/material'
import { FC } from 'react'
import { useRecoilValue } from 'recoil'
import { LoadingBackdrop } from '~/components/LoadingBackdrop'
import { autoPlayState } from '~/features/setting/store'
import browserEnv from '~/libs/env/browserEnv'
import { useVideoDetail } from '../hooks/useVideoDetail'
import VideoDetailInfo from './VideoDetailInfo'
import VideoDetailTabs from './VideoDetailTabs'
import { VideoEventHandlerProvider } from './VideoEventHandlerProvider'
import VideoUnavailable from './VideoUnavailable'
import { NextVideo } from './player/NextVideo'
import Player from './player/Player'
import TrailerPlayer from './player/TrailerPlayer'
import VideoPlayer from './player/VideoPlayer'

const VideoDetailContent: FC<{ id: string }> = ({ id }) => {
  const { isTrailer, unavailableReason } = useVideoDetail(id)

  if (isTrailer === undefined) {
    return <LoadingBackdrop />
  }

  return (
    <>
      <Container maxWidth='xl' disableGutters>
        <Stack paddingX={4} paddingTop={{ xs: 0, sm: 4 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={8}>
              <MainBox isTrailer={isTrailer} id={id} />
            </Grid>
            <Grid item xs={12} sm={4}>
              {isTrailer ? (
                <Hidden smDown>
                  <VideoUnavailable unavailableReason={unavailableReason} />
                </Hidden>
              ) : (
                <VideoDetailTabs id={id} />
              )}
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </>
  )
}

const MainBox: FC<{ isTrailer: boolean; id: string }> = ({ isTrailer, id }) => {
  const autoPlay = useRecoilValue(autoPlayState)

  return (
    <>
      <Box
        sx={{
          position: { xs: 'fixed', sm: 'relative' },
          zIndex: 100,
          left: { xs: 0, sm: 'auto' },
          right: { xs: 0, sm: 'auto' },
        }}
      >
        {isTrailer ? (
          <TrailerPlayer id={id} />
        ) : (
          <div>
            <VideoEventHandlerProvider>
              {browserEnv.NEXT_PUBLIC_ENV === 'production' ? (
                <Player id={id} />
              ) : (
                <VideoPlayer id={id} />
              )}
              {autoPlay && <NextVideo id={id} />}
            </VideoEventHandlerProvider>
          </div>
        )}
      </Box>
      <VideoDetailInfo id={id} />
    </>
  )
}

export default VideoDetailContent
